import { render, staticRenderFns } from "./GridMenu.vue?vue&type=template&id=3e2c1be4"
import script from "./GridMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./GridMenu.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports